module.exports = __WEBPACK_EXTERNAL_MODULE_jspdf__;